var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-full h-screen flex items-center justify-center"},[_c('div',{staticClass:"max-w-lg px-4"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.$store.state.posts.about.body[_vm.locale()])}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }